// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		suggestionStyle: 'style2',
		suggestionMobileStyle: 'style2'
	},
	selector: {
		otpButtons: '.product-card__content .product-card__description'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {};

	SearchInput.prototype.afterBindEvents = function() {
		// Fix cannot close search suggestion when clicking overlay
		document.addEventListener('click', function(e) {
			if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
				var $clickedElement = jQ(e.target);
				var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
				if (isClickSuggestion) {
					this.searchAutoComplete.$element.hide();
					this.searchAutoComplete.searchInput.onCloseAutocomplete();
					this.searchAutoComplete.isOpen = false;
				}
			}
		}.bind(this), true);
	}

	InstantSearchResultItemProduct.prototype.afterRender = function () {
		if (!this.data || !this.isShow) return

		var searchPriceForCall = false;

		var tag = this.data.tags;

		if (tag.indexOf('epos:call-for-price:true') !== -1 || tag.indexOf('epos:call-for-price:1') !== -1) {
			searchPriceForCall = true;
		}

		if (searchPriceForCall === true) {
			this.$element.find('.boost-pfs-search-suggestion-product-price').remove();
		}

		var productUrl = '/products/' + Utils.buildProductItemUrlWithVariant(this.data).split('/products/')[1];
		this.$element.find('.boost-pfs-search-suggestion-item > a')[0].href = productUrl;

		/*var imagesQuantity = Object.keys(this.data.images).length

		if(imagesQuantity < 1) {
			var image = this.$element.find('img');

			image.src = Utils.optimizeImage('https:'+ boostPFSSearchConfig.fallback_image, '100x');
			console.log('image', image);

		}*/

	}
})();
